const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')

const moduleRoute = {
  path: '/actions',
  component: Module,
  children: [
    {
      path: '/actions-settings',
      component: Home,
      name: 'actions-settings',
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
